<div class="flex items-center min-w-60 font-light text-sm subpixel-antialiased text-gray-500">
    <!-- <img src="images/logo/logo.svg" alt="iApply Logo" class="object-fit h-6 w-6 mr-2" /> -->
    @if (title) {
        {{title}}
    }
    @if (appVersion) {
        v{{appVersion}}
    }
    @if (showCopyright) {
        &copy; {{currentYear}}
        <!-- &copy; 2011&mdash;{{currentYear}} -->
    }
</div>
